import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatIcon from "@mui/icons-material/Chat";
import InviteIcon from "@mui/icons-material/ForwardToInbox";
import HomeIcon from "@mui/icons-material/Home";
import StorefrontIcon from "@mui/icons-material/Storefront";

import constants from "../../assets/constants";

const { appPaths, userGroups } = constants;

// Single source of truth for the botpress portal sections — used by both the
// left nav drawer (for navigation + active state) and the app bar (to label the
// current portal). Each section knows how to be reached per user group
// (targetByGroup) and which routes belong to it (routes).
//
// `primary` sections appear as icons in the drawer's main nav rail. Non-primary
// sections (e.g. Invites) are reachable from elsewhere but still need an entry
// here so the app bar can label them when the user lands on their route.
export const PORTAL_SECTIONS = [
  {
    key: "Dashboard",
    label: "Dashboard",
    Icon: HomeIcon,
    primary: true,
    targetByGroup: {
      [userGroups.Administrator]: "/",
      [userGroups.Provider]: "/",
      [userGroups.Partner]: "/",
    },
    // Portal "home" routes all resolve to the Dashboard.
    routes: [appPaths.appPathAdmin, appPaths.appPathProvider, appPaths.appPathPartner, "/"],
  },
  {
    key: "Conversations",
    label: "Conversations",
    Icon: ChatIcon,
    primary: true,
    targetByGroup: {
      [userGroups.Administrator]: appPaths.appPathAdminBotpressConversations,
      [userGroups.Provider]: appPaths.appPathProviderBotpressConversations,
      [userGroups.Partner]: appPaths.appPathPartnerBotpressConversations,
    },
    routes: [
      appPaths.appPathAdminBotpressConversations,
      appPaths.appPathProviderBotpressConversations,
      appPaths.appPathPartnerBotpressConversations,
    ],
  },
  {
    key: "Testing",
    label: "Testing",
    Icon: AssignmentRoundedIcon,
    primary: true,
    targetByGroup: {
      [userGroups.Administrator]: appPaths.appPathAdminBotpressTestHarness,
      [userGroups.Provider]: appPaths.appPathProviderBotpressTestHarness,
      [userGroups.Partner]: appPaths.appPathPartnerBotpressTestHarness,
    },
    routes: [
      appPaths.appPathAdminBotpressTestHarness,
      appPaths.appPathProviderBotpressTestHarness,
      appPaths.appPathPartnerBotpressTestHarness,
    ],
  },
  {
    key: "Admin",
    label: "Admin",
    Icon: AdminPanelSettingsIcon,
    primary: true,
    targetByGroup: {
      [userGroups.Administrator]: appPaths.appPathAdminBotpressAdmin,
      [userGroups.Provider]: appPaths.appPathProviderBotpressAdmin,
      [userGroups.Partner]: appPaths.appPathPartnerBotpressAdmin,
    },
    routes: [
      appPaths.appPathAdminBotpressAdmin,
      appPaths.appPathProviderBotpressAdmin,
      appPaths.appPathPartnerBotpressAdmin,
    ],
  },
  {
    key: "Sales",
    label: "Sales",
    Icon: StorefrontIcon,
    primary: true,
    targetByGroup: {
      [userGroups.Administrator]: appPaths.appPathAdminBotpressSales,
      [userGroups.Provider]: appPaths.appPathProviderBotpressSales,
      [userGroups.Partner]: appPaths.appPathPartnerBotpressSales,
    },
    routes: [
      appPaths.appPathAdminBotpressSales,
      appPaths.appPathProviderBotpressSales,
      appPaths.appPathPartnerBotpressSales,
    ],
  },
  {
    key: "Invites",
    label: "Invites",
    Icon: InviteIcon,
    // Reached from the drawer's account section, not the main rail.
    primary: false,
    targetByGroup: {
      [userGroups.Administrator]: appPaths.appPathAdminInvite,
      [userGroups.Provider]: appPaths.appPathProviderInvite,
    },
    routes: [appPaths.appPathAdminInvite, appPaths.appPathProviderInvite],
  },
];

// Primary sections only — the drawer's main navigation rail.
export const PRIMARY_PORTAL_SECTIONS = PORTAL_SECTIONS.filter(section => section.primary);

// Resolve which section the given pathname belongs to. Anything unrecognized
// (or a portal "home" route) falls back to the Dashboard.
export const getCurrentPortalSection = route =>
  PORTAL_SECTIONS.find(section => section.routes.includes(route)) ?? PORTAL_SECTIONS[0];
